(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silidog-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sdbb) { return; }
    window.__sdbb = true;

    var TIERS = [
      { min: 2, pct: 10 },
      { min: 3, pct: 15 },
      { min: 4, pct: 20 }
    ];
    // Domestic delivery profile: Standard Free Shipping at TOTAL_PRICE >= $28,
    // evaluated on the DISCOUNTED subtotal. It is not a 4+ perk — 2 tags come
    // to $35.98 and already qualify. (Verified against the shipping zones
    // 2026-09-17; the old copy oversold the threshold by two tags.)
    var FREE_SHIP_CENTS = 2800;
    function isFreeShip(discountedCents) { return discountedCents >= FREE_SHIP_CENTS; }
    var FILL_MAP = { 0: 0, 1: 16.66, 2: 33.33, 3: 66.66 };

    function getTier(qty) {
      var found = null;
      for (var i = 0; i < TIERS.length; i++) {
        if (qty >= TIERS[i].min) { found = TIERS[i]; }
      }
      return found;
    }

    function getNextTier(qty) {
      for (var i = 0; i < TIERS.length; i++) {
        if (qty < TIERS[i].min) { return TIERS[i]; }
      }
      return null;
    }

    // The ask, phrased by position rather than by arithmetic.
    var ASK = {
      0: 'Add 2 tags for 10% off & free shipping',
      1: 'Add another tag for 10% off & free shipping',
      2: 'Add a third tag for 15% off',
      3: 'Add a fourth for 20% off',
      4: 'You\u2019ve unlocked 20% off & free shipping'
    };
    function progressMessage(qty) { return ASK[Math.min(qty, 4)]; }

    function money(cents) {
      // presentment-currency aware (operator 2026-08-12: hardcoded "$" showed
      // "$2000.00" to INR visitors). Falls back to $ if Intl/currency missing.
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function initInstance(root) {
      var cards = root.querySelectorAll('[data-sdbb-card]');
      var tabs = root.querySelectorAll('[data-sdbb-tab]');
      var summary = root.querySelector('[data-sdbb-summary]');
      var hint = root.querySelector('[data-sdbb-hint]');
      var list = root.querySelector('[data-sdbb-list]');
      var totalsEl = root.querySelector('[data-sdbb-totals]');
      var subtotalEl = root.querySelector('[data-sdbb-subtotal]');
      var discRow = root.querySelector('[data-sdbb-discrow]');
      var discLabel = root.querySelector('[data-sdbb-disclabel]');
      var discountEl = root.querySelector('[data-sdbb-discount]');
      var shipRow = root.querySelector('[data-sdbb-shiprow]');
      var summaryEl = root.querySelector('[data-sdbb-summary]');
      var collapseBtn = root.querySelector('[data-sdbb-collapse]');
      var miniEl = root.querySelector('[data-sdbb-mini]');
      var collapseLabel = root.querySelector('[data-sdbb-collapse-label]');
      if (collapseBtn && summaryEl) {
        collapseBtn.addEventListener('click', function () {
          var collapsed = summaryEl.dataset.collapsed === 'true';
          summaryEl.dataset.collapsed = String(!collapsed);
          collapseBtn.setAttribute('aria-expanded', String(collapsed));
          if (collapseLabel) { collapseLabel.textContent = collapsed ? 'Hide' : 'Show'; }
        });
      }
      var totalEl = root.querySelector('[data-sdbb-total]');
      var cta = root.querySelector('[data-sdbb-cta]');
      var errorEl = root.querySelector('[data-sdbb-error]');
      var msgEls = root.querySelectorAll('[data-sdbb-msg]');
      var fillEls = root.querySelectorAll('[data-sdbb-fill]');
      var tickEls = root.querySelectorAll('[data-sdbb-tick]');
      var barValEl = root.querySelector('[data-sdbb-barval]');
      var puckEl = root.querySelector('[data-sdbb-puck]');
      var mtierEl = root.querySelector('[data-sdbb-mtier]');
      var nodeEls = root.querySelectorAll('[data-sdbb-node]');

      var state = [];
      var activeTab = 'all';

      function findItem(vid) {
        for (var i = 0; i < state.length; i++) {
          if (state[i].vid === vid) { return state[i]; }
        }
        return null;
      }

      function totalQty() {
        return state.reduce(function (sum, item) { return sum + item.qty; }, 0);
      }

      function subtotal() {
        return state.reduce(function (sum, item) { return sum + item.price * item.qty; }, 0);
      }

      function removeItem(vid) {
        state = state.filter(function (item) { return item.vid !== vid; });
        cards.forEach(function (card) {
          if (Number(card.dataset.variant) === vid) { closePanel(card); }
        });
        render();
      }

      function setQty(vid, qty) {
        var item = findItem(vid);
        if (!item) { return; }
        if (qty <= 0) { removeItem(vid); return; }
        item.qty = qty;
        render();
      }

      // ---- per-card personalization panel: capture the name (required) + phone
      // (optional) BEFORE the item joins state/the bundle. ----
      // Panels are re-parented to <body> so the fixed overlay escapes the card's
      // transform/stacking context (otherwise sticky bars paint on top of it).
      function getPanel(card) {
        return card._sdbbPanel || card.querySelector('[data-sdbb-panel]');
      }

      function closePanel(card) {
        var panel = getPanel(card);
        var addBtn = card.querySelector('[data-sdbb-add]');
        if (panel) { panel.hidden = true; }
        if (addBtn) { addBtn.setAttribute('aria-expanded', 'false'); }
      }

      function closeAllPanels(exceptCard) {
        cards.forEach(function (card) {
          if (card !== exceptCard) { closePanel(card); }
        });
      }

      function updateConfirmState(panel) {
        var nameInput = panel.querySelector('[data-sdbb-panel-name]');
        var confirmBtn = panel.querySelector('[data-sdbb-panel-confirm]');
        var valid = nameInput.value.trim().length > 0;
        confirmBtn.setAttribute('aria-disabled', valid ? 'false' : 'true');
      }

      function openPanel(card) {
        var panel = getPanel(card);
        var addBtn = card.querySelector('[data-sdbb-add]');
        if (!panel) { return; }
        closeAllPanels(card);
        var nameInput = panel.querySelector('[data-sdbb-panel-name]');
        var phoneInput = panel.querySelector('[data-sdbb-panel-phone]');
        var line3Input = panel.querySelector('[data-sdbb-panel-line3]');
        var line4Input = panel.querySelector('[data-sdbb-panel-line4]');
        var hintEl = panel.querySelector('[data-sdbb-panel-hint]');
        var item = findItem(Number(card.dataset.variant));
        nameInput.value = item ? item.name || '' : '';
        phoneInput.value = item ? item.phone || '' : '';
        line3Input.value = item ? item.line3 || '' : '';
        line4Input.value = item ? item.line4 || '' : '';
        nameInput.classList.remove('is-invalid');
        hintEl.hidden = true;
        updateConfirmState(panel);
        panel.hidden = false;
        if (addBtn) { addBtn.setAttribute('aria-expanded', 'true'); }
        nameInput.focus();
      }

      function confirmPanel(card) {
        var panel = getPanel(card);
        var nameInput = panel.querySelector('[data-sdbb-panel-name]');
        var phoneInput = panel.querySelector('[data-sdbb-panel-phone]');
        var line3Input = panel.querySelector('[data-sdbb-panel-line3]');
        var line4Input = panel.querySelector('[data-sdbb-panel-line4]');
        var hintEl = panel.querySelector('[data-sdbb-panel-hint]');
        var name = nameInput.value.trim();
        if (!name) {
          hintEl.hidden = false;
          nameInput.classList.add('is-invalid');
          nameInput.focus();
          return;
        }
        hintEl.hidden = true;
        nameInput.classList.remove('is-invalid');
        var vid = Number(card.dataset.variant);
        var phone = phoneInput.value.trim();
        var line3 = line3Input.value.trim();
        var line4 = line4Input.value.trim();
        var existing = findItem(vid);
        if (existing) {
          existing.name = name;
          existing.phone = phone;
          existing.line3 = line3;
          existing.line4 = line4;
        } else {
          state.push({
            vid: vid,
            title: card.dataset.title || '',
            price: Number(card.dataset.price) || 0,
            compare: Number(card.dataset.compare) || 0,
            img: card.dataset.img || '',
            qty: 1,
            name: name,
            phone: phone,
            line3: line3,
            line4: line4
          });
        }
        closePanel(card);
        render();
      }

      function renderProgress() {
        var qty = totalQty();
        var pct = qty >= 4 ? 100 : (FILL_MAP[qty] !== undefined ? FILL_MAP[qty] : 100);
        fillEls.forEach(function (el) { el.style.width = pct + '%'; });
        if (puckEl) { puckEl.style.left = pct + '%'; }
        nodeEls.forEach(function (el) {
          var at = parseInt(el.dataset.sdbbNode, 10);
          el.classList.toggle('is-reached', qty >= at);
        });
        var msg = progressMessage(qty);
        msgEls.forEach(function (el) { el.textContent = msg; });

        var tierNow = getTier(qty);
        var discounted = subtotal() - Math.round(subtotal() * (tierNow ? tierNow.pct : 0) / 100);
        if (barValEl) { barValEl.textContent = money(discounted); }
        if (mtierEl) { mtierEl.dataset.ship = (qty > 0 && isFreeShip(discounted)) ? 'on' : 'off'; }
        tickEls.forEach(function (el) {
          el.classList.toggle('is-reached', qty >= parseInt(el.dataset.sdbbTick, 10));
        });
      }

      function renderBadges() {
        var totals = {};
        cards.forEach(function (card) {
          var item = findItem(Number(card.dataset.variant));
          if (!item) { return; }
          var coll = card.dataset.collection;
          totals[coll] = (totals[coll] || 0) + item.qty;
        });
        var allTotal = totalQty();
        tabs.forEach(function (tab) {
          var key = tab.dataset.sdbbTab;
          var count = key === 'all' ? allTotal : (totals[key] || 0);
          var badge = tab.querySelector('[data-sdbb-badge]');
          if (badge) {
            badge.textContent = String(count);
            badge.hidden = count === 0;
          }
        });
      }

      function renderCards() {
        cards.forEach(function (card) {
          var isIn = !!findItem(Number(card.dataset.variant));
          card.classList.toggle('is-in', isIn);
          var btn = card.querySelector('[data-sdbb-add]');
          if (btn && !btn.disabled) {
            var label = btn.querySelector('[data-sdbb-add-label]');
            if (label) { label.textContent = isIn ? 'Edit' : 'Add'; }
            btn.classList.toggle('is-in', isIn);
          }
          var badge = card.querySelector('[data-sdbb-inbadge]');
          if (badge) { badge.hidden = !isIn; }
        });
      }

      function renderSummary() {
        var qty = totalQty();

        if (!qty) {
          if (hint) { hint.hidden = false; }
          if (list) { list.hidden = true; list.innerHTML = ''; }
          if (totalsEl) { totalsEl.hidden = true; }
          if (cta) { cta.disabled = true; cta.textContent = 'Add bundle to cart'; }
          return;
        }

        if (hint) { hint.hidden = true; }

        if (list) {
          list.hidden = false;
          list.innerHTML = state.map(function (item) {
            var safeTitle = escapeHtml(item.title);
            // Name/phone are captured on the card BEFORE the item ever reaches state (see
            // confirmPanel) — this is a read-only recap, not an input, so there is only one
            // editable place for it (avoids the earlier duplicate-input/focus-loss issue).
            var nameLine = '';
            if (item.name) {
              var extras = [item.phone, item.line3, item.line4].filter(Boolean).map(escapeHtml).join(' &middot; ');
              nameLine = '<span class="sdbb__item-name">For ' + escapeHtml(item.name) + (extras ? ' &middot; ' + extras : '') + '</span>';
            }
            return (
              '<li class="sdbb__item" data-sdbb-item>' +
                '<img class="sdbb__item-thumb" src="' + escapeHtml(item.img) + '" alt="" width="44" height="44" loading="lazy">' +
                '<div class="sdbb__item-main">' +
                  '<div class="sdbb__item-head">' +
                    '<span class="sdbb__item-title">' + safeTitle + '</span>' +
                    '<button type="button" class="sdbb__item-remove" data-sdbb-remove="' + item.vid + '" aria-label="Remove ' + safeTitle + ' from bundle">&times;</button>' +
                  '</div>' +
                  nameLine +
                  '<div class="sdbb__item-row">' +
                    '<span class="sdbb__item-qty">' +
                      '<button type="button" data-sdbb-dec="' + item.vid + '" aria-label="Decrease quantity">&minus;</button>' +
                      '<span>' + item.qty + '</span>' +
                      '<button type="button" data-sdbb-inc="' + item.vid + '" aria-label="Increase quantity">+</button>' +
                    '</span>' +
                    '<span class="sdbb__item-price">' + money(item.price * item.qty) + '</span>' +
                  '</div>' +
                '</div>' +
              '</li>'
            );
          }).join('');
        }

        var sub = subtotal();
        var tier = getTier(qty);
        var pct = tier ? tier.pct : 0;
        var discount = Math.round(sub * pct / 100);
        var total = sub - discount;

        if (subtotalEl) { subtotalEl.textContent = money(sub); }
        if (discRow) {
          discRow.hidden = pct === 0;
          if (discLabel) { discLabel.textContent = 'Bundle discount (' + pct + '%)'; }
          if (discountEl) { discountEl.textContent = '−' + money(discount); }
        }
        if (shipRow) { shipRow.hidden = !isFreeShip(total); }
        if (totalsEl) { totalsEl.hidden = false; }
        if (totalEl) { totalEl.textContent = money(total); }
        if (miniEl) {
          miniEl.hidden = qty === 0;
          miniEl.textContent = qty + (qty === 1 ? ' tag \u00b7 ' : ' tags \u00b7 ') + money(total);
        }
        if (cta) {
          cta.disabled = false;
          cta.textContent = tier ? 'Checkout — save ' + pct + '%' : 'Checkout';
        }
        if (errorEl) { errorEl.hidden = true; }
      }

      function measureDock() {
        if (!summary || !root.isConnected) { return; }
        if (window.matchMedia('(min-width: 990px)').matches) {
          root.style.setProperty('--sdbb-dock-h', '0px');
          return;
        }
        var height = Math.ceil(summary.getBoundingClientRect().height);
        root.style.setProperty('--sdbb-dock-h', height + 'px');
      }

      function render() {
        renderProgress();
        renderBadges();
        renderCards();
        renderSummary();
        window.requestAnimationFrame(measureDock);
      }

      function setActiveTab(key) {
        activeTab = key;
        tabs.forEach(function (tab) {
          var on = tab.dataset.sdbbTab === key;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          card.hidden = !(key === 'all' || card.dataset.collection === key);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { setActiveTab(tab.dataset.sdbbTab); });
      });

      cards.forEach(function (card) {
        var btn = card.querySelector('[data-sdbb-add]');
        var panel = getPanel(card);
        if (btn && !btn.disabled) {
          // Always opens the panel — whether this is a first-time "Add" or an
          // "Edit" on an item already in the bundle (openPanel prefills either way).
          btn.addEventListener('click', function () { openPanel(card); });
        }
        if (panel) {
          // escape the card's stacking/transform context so the fixed overlay
          // truly covers the page (sticky bars, summary) — see getPanel().
          // The --sdbb-* custom properties live inline on the section root, so
          // carry them onto the re-parented panel.
          panel.setAttribute('style', root.getAttribute('style') || '');
          document.body.appendChild(panel);
          card._sdbbPanel = panel;
          var nameInput = panel.querySelector('[data-sdbb-panel-name]');
          var confirmBtn = panel.querySelector('[data-sdbb-panel-confirm]');
          nameInput.addEventListener('input', function () { updateConfirmState(panel); });
          confirmBtn.addEventListener('click', function () { confirmPanel(card); });
          panel.querySelectorAll('[data-sdbb-panel-cancel]').forEach(function (btn) {
            btn.addEventListener('click', function () { closePanel(card); });
          });
          // modal behaviours: click the backdrop or press Escape to close, Enter confirms
          panel.addEventListener('click', function (evt) { if (evt.target === panel) { closePanel(card); } });
          panel.addEventListener('keydown', function (evt) {
            if (evt.key === 'Escape') { closePanel(card); }
            else if (evt.key === 'Enter' && evt.target.matches('input')) { evt.preventDefault(); confirmPanel(card); }
          });
        }
      });

      if (list) {
        list.addEventListener('click', function (evt) {
          var dec = evt.target.closest('[data-sdbb-dec]');
          var inc = evt.target.closest('[data-sdbb-inc]');
          var rem = evt.target.closest('[data-sdbb-remove]');
          if (dec) {
            var decItem = findItem(Number(dec.dataset.sdbbDec));
            if (decItem) { setQty(decItem.vid, decItem.qty - 1); }
          } else if (inc) {
            var incItem = findItem(Number(inc.dataset.sdbbInc));
            if (incItem) { setQty(incItem.vid, incItem.qty + 1); }
          } else if (rem) {
            removeItem(Number(rem.dataset.sdbbRemove));
          }
        });
      }

      if (cta) {
        cta.addEventListener('click', function () {
          if (!state.length || cta.disabled) { return; }
          var previousLabel = cta.textContent;
          cta.disabled = true;
          cta.textContent = 'Adding…';
          var payload = {
            items: state.map(function (item) {
              var props = {};
              if (item.name) { props.line1 = item.name; }
              if (item.phone) { props.line2 = item.phone; }
              if (item.line3) { props.line3 = item.line3; }
              if (item.line4) { props.line4 = item.line4; }
              return { id: Number(item.vid), quantity: item.qty, properties: props };
            })
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'Add to cart failed');
              });
            }
            return response.json();
          }).then(function () {
            window.location.href = '/checkout';
          }).catch(function (err) {
            cta.disabled = false;
            cta.textContent = previousLabel;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = (err && err.message) || 'Something went wrong. Please try again.';
            }
          });
        });
      }

      window.addEventListener('resize', function () { measureDock(); }, { passive: true });

      setActiveTab('all');
      render();
    }

    function boot() {
      document.querySelectorAll('.sdbb').forEach(function (root) { initInstance(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
